<script setup lang="ts">
import type { IconName } from '@ui/components/icon/types'
import type { NuxtLinkProps } from 'nuxt/app'
import { resolveComponent } from 'vue'
import Icon from '../icon/Icon.vue'

withDefaults(
  defineProps<{
    name?: IconName
    disabled?: boolean
    to?: NuxtLinkProps['to']
    external?: boolean
    target?: string
    loading?: boolean
  }>(),
  {
    name: '',
    disabled: false,
    to: '',
    external: false,
    loading: false,
  },
)

const NuxtLink = resolveComponent('NuxtLink')
</script>

<template lang="pug">
component.icon-button.p-0.m-0.flex-shrink-0(
  :is="to ? NuxtLink : 'button'"
  type="button"
  :to="to"
  :target="target"
  :disabled="disabled"
  :external="external"
)
  Icon.w-100p.h-100p(:name="name" :loading="loading")
</template>

<style scoped>
.icon-button {
  background: none;
  border: none;
  color: var(--cue-content-neutral-disabled);
  transition: 0.2s ease;
  transition-property: color;

  &:not(:disabled) {
    cursor: pointer;
    color: var(--cue-content-neutral-primary);

    &:hover {
      filter: opacity(50%);
    }
  }

  &:disabled {
    cursor: not-allowed;
  }
}
</style>
